import { ENV } from '@config/env';
import { FEATURES } from '@config/features';

/**
 * Device-performance diagnostic — calibration proof of concept, not a product
 * feature. See ./README.md.
 *
 * The route exists only when FEATURES.DEVICE_PERFORMANCE_DIAGNOSTIC is on AND
 * the environment is not production. Otherwise routes/index.jsx never
 * registers it and the lazy chunk is never loaded; the pose-probe calls left
 * in the real loop are one null check each.
 */
export const isDevicePerformanceDiagnosticEnabled = () =>
  Boolean(FEATURES.DEVICE_PERFORMANCE_DIAGNOSTIC) && !ENV.isProduction;

export const DEVICE_PERFORMANCE_ROUTE = '/debug/device-performance';
